import { Link } from 'react-router-dom';
import { useSettings } from '@/context/SettingsContext';
import { Instagram, Linkedin, Youtube } from 'lucide-react';

export const Footer = () => {
  const { settings } = useSettings();

  const logo = settings?.theme?.logo || '/logo.png';
  const companyName = settings?.company?.name || 'Hangar Desarrollos';
  const description = settings?.footer?.description || '';
  const links = settings?.footer?.links || [];
  const contact = settings?.contact || {};
  const primaryColor = settings?.theme?.primaryColor || '#1e3a5f';
  const socialMedia = settings?.socialMedia || {};

  return (
    <footer className="border-t border-slate-200">
      <div className="container-safe grid gap-10 py-12 md:grid-cols-3">
        <div className="space-y-4">
          <img 
            src="/logo-new.png" 
            alt="Hangar Desarrollos" 
            style={{ height: '55px', width: 'auto' }}
          />
          <p className="text-sm leading-relaxed text-slate-600">
            {description}
          </p>
          
          {/* Redes Sociales */}
          <div className="flex items-center gap-3">
            {socialMedia.instagramEnabled && socialMedia.instagram && (
              <a
                href={socialMedia.instagram}
                target="_blank"
                rel="noreferrer"
                className="flex h-9 w-9 items-center justify-center rounded-lg bg-slate-100 text-slate-700 hover:bg-slate-200 transition-colors"
                aria-label="Instagram"
                data-testid="social-instagram"
              >
                <Instagram size={18} />
              </a>
            )}
            {socialMedia.linkedinEnabled && socialMedia.linkedin && (
              <a
                href={socialMedia.linkedin}
                target="_blank"
                rel="noreferrer"
                className="flex h-9 w-9 items-center justify-center rounded-lg bg-slate-100 text-slate-700 hover:bg-slate-200 transition-colors"
                aria-label="LinkedIn"
                data-testid="social-linkedin"
              >
                <Linkedin size={18} />
              </a>
            )}
            {socialMedia.youtubeEnabled && socialMedia.youtube && (
              <a
                href={socialMedia.youtube}
                target="_blank"
                rel="noreferrer"
                className="flex h-9 w-9 items-center justify-center rounded-lg bg-slate-100 text-slate-700 hover:bg-slate-200 transition-colors"
                aria-label="YouTube"
                data-testid="social-youtube"
              >
                <Youtube size={18} />
              </a>
            )}
          </div>
        </div>

        <div className="space-y-3">
          <div className="text-sm font-semibold text-slate-900">Secciones</div>
          <div className="grid gap-2 text-sm">
            {links.map((link, idx) => (
              <a
                key={idx}
                className="text-slate-600 hover:text-slate-900 transition-colors"
                href={link.href}
                style={{ '--hover-color': primaryColor }}
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>

        <div className="space-y-3">
          <div className="text-sm font-semibold text-slate-900">Contacto</div>
          <div className="text-sm text-slate-600">
            <div>{contact.locationLine1 || contact.location}</div>
            {contact.locationLine2 && <div>{contact.locationLine2}</div>}
            {contact.email && (
              <div className="mt-2">
                Email:{' '}
                <a
                  className="underline decoration-slate-300 hover:decoration-slate-900"
                  href={`mailto:${contact.email}`}
                >
                  {contact.email}
                </a>
              </div>
            )}
            {contact.whatsapp && (
              <div className="mt-2">
                WhatsApp:{' '}
                <a
                  className="underline decoration-slate-300 hover:decoration-slate-900"
                  href={`https://wa.me/${contact.whatsapp}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  +{contact.whatsapp.replace(/^(\d{2})(\d{2})(\d{2})(\d+)$/, '$1 $2 $3 $4')}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="border-t border-slate-200 py-6">
        <div className="container-safe text-center text-xs text-slate-500">
          <div>© {new Date().getFullYear()} {companyName}. Todos los derechos reservados.</div>
        </div>
      </div>
    </footer>
  );
};
